import React, { useState } from 'react';

function Login({ onLoginSuccess }) {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      // IMPORTANT: Replace with your actual Hostinger domain URL
      const apiUrl = 'https://electroweighing.com/login.php'; // UPDATE THIS!
      
      const response = await fetch(apiUrl, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ username, password })
      });
      
      if (!response.ok) {
        alert(`Server error: ${response.status} ${response.statusText}`);
        return;
      }
      
      const data = await response.json();
      console.log('Response from server:', data); // Debug log
      
      if (data.success) {
        try {
          if (data.user) {
            localStorage.setItem('lbUser', JSON.stringify(data.user));
          }
        } catch (e) {
          console.warn('Failed to store user in localStorage', e);
        }
        alert('Login successful!');
        // Call the callback to navigate to dashboard
        if (onLoginSuccess) {
          onLoginSuccess(data.user || null);
        }
      } else {
        alert(`Login failed: ${data.error || 'Invalid credentials'}\n${data.details || ''}\n${data.hint || ''}`);
      }
    } catch (error) {
      console.error('Error:', error);
      alert(`Error connecting to server: ${error.message}`);
    }
  };

  return (
    <main style={{ minHeight: '300px', display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center' }}>
      <h2>Login</h2>
      <form onSubmit={handleSubmit} style={{ display: 'flex', flexDirection: 'column', gap: '16px', width: '260px' }}>
        <input
          type="text"
          placeholder="Username"
          value={username}
          onChange={e => setUsername(e.target.value)}
          required
          style={{ padding: '10px', fontSize: '1rem' }}
        />
        <input
          type="password"
          placeholder="Password"
          value={password}
          onChange={e => setPassword(e.target.value)}
          required
          style={{ padding: '10px', fontSize: '1rem' }}
        />
        <button type="submit" style={{ padding: '10px 30px', fontSize: '1rem' }}>Login</button>
      </form>
    </main>
  );
}

export default Login;
